import { render, staticRenderFns } from "./Point.md?vue&type=template&id=2b2211c6&"
import script from "./Point.md?vue&type=script&lang=js&"
export * from "./Point.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2211c6')) {
      api.createRecord('2b2211c6', component.options)
    } else {
      api.reload('2b2211c6', component.options)
    }
    module.hot.accept("./Point.md?vue&type=template&id=2b2211c6&", function () {
      api.rerender('2b2211c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/plugins/Point.md"
export default component.exports